import { render } from "./MinhasConsultas.vue?vue&type=template&id=5d5edb4a"
import script from "./MinhasConsultas.vue?vue&type=script&lang=js"
export * from "./MinhasConsultas.vue?vue&type=script&lang=js"

import "./MinhasConsultas.vue?vue&type=style&index=0&id=5d5edb4a&lang=css"

import exportComponent from "C:\\Users\\User\\Documents\\PROJETOS - LEFISC\\front_revisor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__